export default function ContactPage() {
  return <h2>📞 Kontakt & Support</h2>;
}
